import React, { useEffect, useMemo, useRef } from 'react'
import { Link } from 'react-router-dom'

import { articleCardClick, collectionCardClick } from '../Analytics/Analytics'
import { NewIconArrow } from '../icons/NewIconArrow'
import { setBodyColor } from '../NewMain2/NewMain2'
import { NewAnonceCard } from '../UI/NewAnonceCard/NewAnonceCard'
import style from './TableLayout.module.scss'
import { TableLayoutProps } from './TableLayout.types'

export const TableLayout = (props: TableLayoutProps) => {
  const { items, title, category, id, exclude, currentPage } = props

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  const filteredReversedData = useMemo(() => {
    const filteredItems = items.filter(item => item.id !== exclude)
    return filteredItems.reverse()
  }, [items, exclude])

  const cardClickHandler = (id: string) => {
    if (category === '/article/') {
      articleCardClick(id, 'articles')
    } else {
      collectionCardClick(id, 'collections')
    }
  }

  useEffect(() => {
    setBodyColor('#fff')
    scrollTo({
      top: 0,
      behavior: 'auto',
    })

    return () => {
      setBodyColor('#f7f7f5')
    }
  }, [])

  return (
    <div className={style.table}>
      <section className='section' id={id}>
        <div className='new-anonce-list'>
          <div className={style.back}>
            <Link
              to='/'
              className={`btn btn--tarnsparent btn--small btn--back`}
            >
              <NewIconArrow />
              На главную
            </Link>
          </div>
          <h2 className='section__title'>{title}</h2>
          <div className='new-cards'>
            <div className='new-cards__items new-cards__items--3'>
              {filteredReversedData.slice(0).map(item => {
                if (exclude && item.id === exclude) {
                  return null
                }
                return (
                  <div key={item.id}>
                    <NewAnonceCard
                      {...item}
                      category={category}
                      currentPage={currentPage}
                      onClick={cardClickHandler}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
